import { Component } from '@angular/core';
import { Subscription } from '../data/subscription';
import { FordService } from '../services/ford.service';
import { InternationalRequest } from '../data/international-request';
import { InternationalRequestService } from '../services/international-request.service';
import { Dealer, DealerCurrent } from '../data/dealer';
import { DealerService } from '../services/dealer.service';
import { FuncsService } from '../services/funcs.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomerCurrent } from '../data/customer';

@Component({
  selector: 'app-request-intl-dealer',
  templateUrl: './request-intl-dealer.component.html',
  styleUrl: './request-intl-dealer.component.css',
  standalone: false
})
export class RequestIntlDealerComponent {
  sub: Subscription = {
    createdAt: "",
    startDate: "",
    siteCode: "",
    maxAllowedUniqueDealerTechnicianLogins: 0,
    concurrentSessions: 0,
    expiresAt: "",
    status: 200
  };

  constructor(
    private dealerService: DealerService,
    private internationalRequestService: InternationalRequestService,
    private fordService: FordService,
    private funcs: FuncsService,
    private _router: Router,
    private route: ActivatedRoute
  ) { }

  public loading = true;
  public f = this.funcs;
  report: InternationalRequest[] = [];
  dealer: Dealer = DealerCurrent;
  selectedOption = "";
  public international = false;
  subscribed: boolean = false;
  tech_count: number = 0;
  tech_count_requested: number = 0;
  public enrolled = "";
  public requestedSubscriptions = 0;
  public isChecked: boolean = false;
  notes: string = "";
  ref: any;
  fleet: boolean = false;

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(queryParams => {
      this.ref = queryParams.get('ref');
      if (this.ref == "fleet") {
        this.fleet = true;
      }
    });
    if (this.ref == "fleet" || CustomerCurrent.role === "FLEET") {
      this.fleet = true;
    }
    this.funcs.currentDealer(this.dealer);
    this.getSubscription();
    this.tech_count = this.dealer.tech_count;
    this.tech_count_requested = this.tech_count || 0;
  }

  getSubscription(): void {
    var reCountryPrefix = /^[A-z]{3}/i;
    if (!reCountryPrefix.test(this.dealer.pa_code) && CustomerCurrent.pa_code === this.dealer.pa_code) {
      this.dealer.pa_code = CustomerCurrent.country3 + this.dealer.pa_code;
      DealerCurrent.pa_code = this.dealer.pa_code;
    }

    this.fordService.getSubscription(this.dealer.pa_code).subscribe(sub => {
      console.log(`PA Code: ${sub.siteCode} , Dealer PA Code: ${this.dealer.pa_code} `);
      if (!sub.startDate) {
        sub.startDate = (new Date(0)).toISOString();
      }
      if (!sub.expiresAt) {
        sub.expiresAt = (new Date(0)).toISOString();
      }
      if (!sub.maxAllowedUniqueDealerTechnicianLogins) {
        sub.maxAllowedUniqueDealerTechnicianLogins = 0;
      }
      this.requestedSubscriptions = sub.maxAllowedUniqueDealerTechnicianLogins;
      if (!sub.concurrentSessions) {
        sub.concurrentSessions = 0;
      }

      this.subscribed = this.funcs.isSubscribed(sub);
      this.international = this.funcs.getThreeLetterCountry(sub.siteCode) !== "USA" && this.funcs.getThreeLetterCountry(sub.siteCode) !== "CAN";

      if (!this.subscribed && this.funcs.getThreeLetterCountry(sub.siteCode) === 'USA' || this.funcs.getThreeLetterCountry(sub.siteCode) === 'CAN') {
        // get our tech count

        if (this.ref == "fleet") {
          this.dealerService.getFleetDealer(this.funcs.stripCountry(sub.siteCode)).subscribe({
            next: (d) => {
              this.tech_count = d.tech_count;
              this.tech_count_requested = this.tech_count;
            },
            error: (err) => this.tech_count = 0,
            complete: () => console.log(this.tech_count)
          });
        } else {
          this.dealerService.getDealer(this.funcs.stripCountry(sub.siteCode)).subscribe({
            next: (d) => {
              this.tech_count = d.tech_count;
            },
            error: (err) => this.tech_count = 0,
            complete: () => console.log(this.tech_count)
          });
        }
      } else {
        this.tech_count = sub.maxAllowedUniqueDealerTechnicianLogins;
        if(this.ref == "fleet") {
          this.tech_count_requested = this.tech_count;          
        }
      }
      this.enrolled = new Date(this.sub.createdAt).toDateString();
    });
  }

  createRequest(): void {
    var newReq: InternationalRequest = <InternationalRequest>{};

    // build new request
    newReq.request_id = 0;
    newReq.username = this.dealer.pa_code;
    newReq.request_date = (new Date(0)).toISOString();
    if (this.fleet) {
      newReq.status = 201;
    } else {
      newReq.status = 101;
    }
    newReq.license_qty_requested = this.tech_count_requested;
    newReq.manager_license_qty_approved = this.tech_count_requested;
    newReq.manager_CDSID = "";
    newReq.manager_title = "";
    newReq.manager_name_1 = "";
    newReq.manager_name_2 = "";
    newReq.bypass_manager = false;

    this.internationalRequestService.createInternationalRequest(newReq).subscribe((id) => {
      if (this.fleet) {
        this.fordService.getSubscription(this.dealer.pa_code).subscribe(s => {
          if (!s.startDate) {
            s.startDate = (new Date(0)).toISOString();
          }
          if (!s.expiresAt) {
            s.expiresAt = (new Date(0)).toISOString();
          }
          if (!s.maxAllowedUniqueDealerTechnicianLogins) {
            s.maxAllowedUniqueDealerTechnicianLogins = 0;
          }

          s.maxAllowedUniqueDealerTechnicianLogins = this.tech_count_requested;

          if (!s.concurrentSessions) {
            s.concurrentSessions = 0;
          }

          this.fordService.addSubscription(s).subscribe(responses => {
            console.log(`response: ` + responses);
          });
        });
        this._router.navigate(['/status-enrolled'], {
          queryParams: { ref: 'fleet' },
        });
      } else {
        // Send email to Sami
        this.internationalRequestService.sendInternationalRequestEmail(newReq.username, "notes").subscribe((s) => {
          // console.log(`email for pa_code ${newReq.username}`);
          this._router.navigateByUrl('/status-enrolled');
        });
      }
    });
  }
}
